export function LinkIsExternal(url: string) {
  const matchers = ['https://', 'http://', 'www.'];
  return matchers.some((matcher) => url.includes(matcher));
}

function LinkHasScheme(url: string) {
  return url.includes('//');
}

export function LinkAddScheme(url: string) {
  if (LinkHasScheme(url)) return url;
  return `//${url}`;
}

function LinkIsMixer(url: string) {
  return url.includes('mixer.thiememeulenhoff.nl');
}

export function LinkAddMixerData(url: string) {
  if (LinkIsMixer(url)) {
    return `${url + (url.includes('?') ? '&' : '?')}source=${window.location.href}`;
  }
  return url;
}
